import { getProductsGridSize } from '@app/ducks';
import cx from 'classnames';
import { useSelector } from 'react-redux';

interface Props {
  isGridView: boolean;
  children: React.ReactNode;
}

export const ProductsView = ({ isGridView, children }: Props) => {
  const productsGridSize = useSelector(getProductsGridSize);

  return (
    <div
      className={cx('ml-4 pb-8 pr-4 pt-3 lg:mr-0 lg:pr-8 lg:pt-1', {
        'gap-x-5 gap-y-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-[repeat(auto-fill,minmax(21.5rem,1fr))]': productsGridSize === 'large',
        grid: isGridView,
        'grid-cols-[repeat(auto-fill,minmax(10.75rem,1fr))] gap-x-1 gap-y-1': productsGridSize === 'small',
        'grid-cols-[repeat(auto-fill,minmax(8.5rem,1fr))] gap-x-3 gap-y-3 md:!grid-cols-[repeat(auto-fill,minmax(13.5rem,1fr))] xs:grid-cols-[repeat(auto-fill,minmax(10rem,1fr))]':
          productsGridSize === 'medium',
        'space-y-5': !isGridView,
      })}
    >
      {children}
    </div>
  );
};
